import { render, staticRenderFns } from "./reasonForChange.vue?vue&type=template&id=7b46c35a&scoped=true&"
import script from "./reasonForChange.vue?vue&type=script&lang=js&"
export * from "./reasonForChange.vue?vue&type=script&lang=js&"
import style0 from "./reasonForChange.vue?vue&type=style&index=0&id=7b46c35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b46c35a",
  null
  
)

export default component.exports